import { defineStore } from 'pinia'
import axiosInstance from '@/services'

export const useDashboardStore = defineStore('dashboard', {
  state: () => {
    return {
      selectionFilter: {
        applicationId: null,
        region: 1,
        module: null,
        service: null,
        subService: null
      },
      applications: [],
      regions: [],
      modules: [],
      services: [],
      subServices: [],
      filterAsSearchText: null
    }
  },
  getters: {
    /**
     * a backwards way to keep a record of the region dropdown
     */
    selectedRegion() {
      if (!this.selectionFilter?.region) return
      return this.regions.find((r) => r.id == this.selectionFilter.region)
    },
    directoryItems() {
      const items = []
      if ((this.modules ?? []).length === 0) return []
      this.modules.forEach((module) => {
        module.moduleServices.forEach((parentService) => {
          parentService.childs.forEach((subService) => {
            subService.serviceTransactions.forEach((transaction) => {
              const serviceNameAsList = [
                module.localizedName,
                parentService.localizedName,
                subService.localizedName,
                transaction.localizedName
              ]

              items.push({
                localizedServiceName: serviceNameAsList.join('-'),
                moduleId: module.id,
                transactionId: transaction.id,
                favactive: ''
              })
            })
          })
        })
      })

      return items
    }
  },
  actions: {
    async fetchApplications(allowedApplications = []) {
      const response = await axiosInstance.get('/api/lookup/applications')

      this.applications = response

      if (allowedApplications.length > 0) {
        this.applications = response.filter((r) => allowedApplications.includes(r.id))
      }

      this.applications = this.applications.map((r) => ({
        ...r,
        label: r.localizedName,
        value: r.id
      }))
    },
    async fetchAdminRegions() {
      const response = await axiosInstance.get('/api/lookup/administrativeRegions')

      this.regions = response.map((r) => ({ ...r, label: r.localizedName, value: r.id }))
    },
    async handleApplicationChange(application) {
      this.selectionFilter.region = []
      this.modules = []
      this.services = []

      this.selectionFilter.applicationId = application.id
    },
    async handleRegionChange(region) {
      if (!region) {
        this.selectionFilter.region = []
        this.modules = []
        this.services = []
        return
      }

      this.selectionFilter.adminRegionId = region.id
      this.selectionFilter.region = region.id
      await this.fetchServiceTransactions()
    },
    async fetchServiceTransactions() {
      const params = {
        includeHiddenServices: false,
        isChildSeleted: false,
        serviceId: null,
        parentServiceId: null,
        sponsorFileTypeId: null,
        administrativeRegionId: this.selectionFilter.region,
        adminRegionId: this.selectionFilter.adminRegionId
      }
      this.modules = await axiosInstance.get('/api/application/service/transactions', { params })
      this.modules = this.modules.map((m) => ({ ...m, label: m.localizedName, value: m.id }))
    },
    handleModuleChange(item) {
      if (item) {
        this.services = item.moduleServices.map((m) => ({
          ...m,
          label: m.localizedName,
          value: m.id
        }))

        this.selectionFilter.module = item
      } else {
        this.services = []
        this.subServices = []
      }

      this.$patch((state) => {
        state.filterAsSearchText = (item && item.localizedName) || null
      })
    },
    handleServiceChange(item) {
      if (item) {
        this.subServices = item.childs.map((m) => ({ ...m, label: m.localizedName, value: m.id }))
        this.selectionFilter.service = item
        this.selectionFilter.subService = null
      } else {
        this.subServices = []
      }

      this.$patch((state) => {
        const newText = [this.selectionFilter.module]
        if (item) {
          newText.push(item)
        }
        state.filterAsSearchText = newText.map((t) => t.localizedName).join('-')
      })
    },
    handleSubserviceChange(item) {
      this.selectionFilter.subService = item

      this.$patch((state) => {
        const newText = [this.selectionFilter.module, this.selectionFilter.service]
        if (item) {
          newText.push(item)
        }
        state.filterAsSearchText = newText.map((t) => t.localizedName).join('-')
      })
    }
  }
})
